import useConfig from "src/hooks/useConfig"
import learnmachineDefaultBgVideo from "../../../assets/media/learnmachine.mp4"
import uttaDefaultBgVideo from "../../../assets/media/login-utta-bgvideo.mp4"

export const ConditionalAuthVideo = () => {
  const { platformName } = useConfig()
  switch (platformName) {
    case "LearnMachine":
      return (
        <video
          src={learnmachineDefaultBgVideo}
          autoPlay
          muted
          loop
          controls={false}
          playsInline
          onContextMenu={e => e.preventDefault()}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      )
    case "Utta":
      return (
        <video
          src={uttaDefaultBgVideo}
          autoPlay
          muted
          loop
          controls={false}
          playsInline
          onContextMenu={e => e.preventDefault()}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      )
    case "x121":
      return (
        <video
          src={"https://x121.ai/override/7/assets/mp4/bgvideo.mp4"}
          autoPlay
          muted
          loop
          controls={false}
          playsInline
          onContextMenu={e => e.preventDefault()}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      )
    default:
      return <></>
  }
}
